<template>
  <div class="md:bg-gray-50 md:py-24">
    <h4 class="text-center ota-small-light mb-4 md:mb-2 md:ota-headline" v-text="$t('Lookbook.ReadyToTry')" />
    <h5 class="hidden text-center ota-subtitle-light md:block md:mb-14" v-text="$t('Lookbook.DesignsInStock')" />
    <div class="text-center">
      <OButton variant="secondary" @click="$emit('click')">
        {{ $t('HomePage.TryForFreeATC') }}
      </OButton>
    </div>
  </div>
</template>

<script>
const OButton = () => import('@/components/OButton')

export default {
  name: 'ReadyToTry',
  components: {
    OButton
  }
}
</script>
